export default __webpack_public_path__ + "static/media/himegami-protocol.f521a7d1.jpg";